import TableCellContent, { TableCellContentProps } from "ds/components/Table/Row/CellContent";

import { RenderItemRowCellProps } from "../Content";
import styles from "../../styles.module.css";
type PersonalSettingsSpacesItemCellProps = Pick<RenderItemRowCellProps, "cellId"> &
  Pick<TableCellContentProps, "children" | "role">;

const PersonalSettingsSpacesItemCell = ({
  cellId,
  role,
  children,
}: PersonalSettingsSpacesItemCellProps) => {
  return (
    <TableCellContent className={styles.cell} id={cellId} role={role}>
      {children}
    </TableCellContent>
  );
};

export default PersonalSettingsSpacesItemCell;
